/* STEP 3 · rule 9 (PR 9, owner 26-Oct-2026 14:39) — EN + AR. Loaded from lib/i18n/ by the generated index (STEP 2 · B2).
   * B-9b — a W9 row below clearly trivial (any source: post-year-end upload, discrepancy, typed by hand …) is listed and
     marked "Clearly trivial", and is left out of the W9 aggregate;
   * B-9c — a coverage figure is a percent; with nothing to cover it reads "Not applicable" (never 0 % or 100 %). */
export const I18N_S3R9 = {
  en: {
    s3r9: {
      ctMark: "Clearly trivial - not accumulated",
      ctMarkTitle: "Below clearly trivial ({ct}): listed here, not added to the aggregate of uncorrected misstatements.",
      ctSummary: "{n} row(s) below clearly trivial ({ct}), total {total}: listed and marked, not in the aggregate.",
      notApplicable: "Not applicable",
      coverageNone: "Nothing to cover (no items in the population).",
    },
  },
  ar: {
    s3r9: {
      ctMark: "غير مؤثر بوضوح - لا يُجمَّع",
      ctMarkTitle: "أقل من الحد غير المؤثر بوضوح ({ct}): مُدرَج هنا ولا يُضاف إلى مجموع التحريفات غير المصحَّحة.",
      ctSummary: "{n} صف(وف) أقل من الحد غير المؤثر بوضوح ({ct})، الإجمالي {total}: مُدرَجة ومُعلَّمة وليست في المجموع.",
      notApplicable: "لا ينطبق",
      coverageNone: "لا يوجد ما يُغطّى (لا بنود في المجتمع).",
    },
  },
};

export default I18N_S3R9;
